// extracted by mini-css-extract-plugin
export default {"contGrafico":"Totales6MesesGrafico_contGrafico__uf1Mn","graph":"Totales6MesesGrafico_graph__QqCt5"};